import { Button, Group, Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useDatasetStore } from '@/store/dataset';

export const CloningTip = () => {
  const { t } = useTranslation();
  const { cloningTipOpened, setCloningTipOpened } = useDatasetStore();

  return (
    <Modal
      centered
      withCloseButton={false}
      opened={cloningTipOpened}
      onClose={() => {
        setCloningTipOpened(false);
      }}
      zIndex={900}
    >
      <Text>{t('dataset.cloning_tip')}</Text>
      <Group justify="flex-end" className="mt-3">
        <Button
          onClick={() => {
            setCloningTipOpened(false);
          }}
        >
          {t('alert_ok')}
        </Button>
      </Group>
    </Modal>
  );
};
